import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {},
	automationsContainer: {
		background: '#fff',
		minHeight: 300,
	},
	createButton: {
		margin: 0,
		transform: 'none',
	},
	header: {
		alignItems: 'flex-end',
		background: 'transparent',
		display: 'flex',
		justifyContent: 'flex-end',
		margin: `20px 0`,
		padding: 0,
	},
});
